import React from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box } from '@mantine/core'

import useStyles from './index.styles'
import { BlockItemPropsType } from '..'

const UnderLine = ({
  title,
  className,
  classNames,
  styles,
  isSelected = false,
  ...boxProps
}: BlockItemPropsType) => {
  const { classes, cx } = useStyles(
    {
      isSelected,
    },
    { name: 'CarePathHeroBannerNavigatorItem__UnderLine', classNames, styles },
  )

  return (
    <Box
      className={cx(className, classes.root, isSelected ? 'selected' : '')}
      {...boxProps}
    >
      <Text className={classes.title} color="inherit" size="p3">
        {title}
      </Text>
    </Box>
  )
}

UnderLine.displayName = 'UnderLine'

export { UnderLine }
